import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@telus-uds/components-web';

import ModalForm from '../modalForm';
import { FieldWrapper } from './css';

const FieldButton = ({ data }) => {
  const { name, label, readonly, modalForms } = data;
  const [isModalOpened, setIsModalOpened] = useState(false);
  const modalForm = modalForms.find(item => item.fields.name === label);
  const modalFormFields =
    modalForm && modalForm.fields && modalForm.fields.formStepFields;

  return (
    <FieldWrapper>
      <Button
        type="button"
        name={name}
        onClick={() => setIsModalOpened(true)}
        variant={{ priority: 'high' }}
        disabled={readonly}
      >
        {label}
      </Button>
      <ModalForm
        fields={modalFormFields}
        open={isModalOpened}
        header={label}
        onClose={() => setIsModalOpened(false)}
      />
    </FieldWrapper>
  );
};

FieldButton.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    readonly: PropTypes.bool,
    modalForms: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired
};

export default FieldButton;
